/* eslint-disable */
import Header from "components/Common/Header/Header";
import CompanyListBody from "components/CompaniesComponents/CompanyList/CompanyListBody/CompanyListBody";
import React, { useEffect } from "react";

const CompaniesLanding = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Companies";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="companies" />

      {/* --------- body section ------------ */}
      <CompanyListBody />
    </main>
  );
};

export default CompaniesLanding;
